/**
 * @desc 通过字典编码列表获取字典信息信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  ObjectMap<string, Array<defs.basics.BaseDictionaryResponseRpcDto>>
>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/findMapByDicCodeList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
